import axios from 'axios';
import {serverconfigs, configTimers} from '../constants';

export default class RouteService {
    drawPolyline(origin, destination){
        return axios.get(serverconfigs.routeUrl + "?api_key=" + serverconfigs.routeApikey +'&origin='+origin+'&destination='+destination, {timeout: configTimers.routeCallTimeOut});
     }
}